var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { createShorthandFactory, UIComponent, commonPropTypes } from '../../lib';
import { imageBehavior } from '../../lib/accessibility';
/**
 * An image is a graphic representation of something.
 * @accessibility
 * If image should be visible to screen readers, textual representation needs to be provided in 'alt' property.
 *
 * Other considerations:
 *  - when alt property is empty, then Narrator in scan mode navigates to image and narrates it as empty paragraph
 *  - when image has role='presentation' then screen readers navigate to the element in scan/virtual mode. To avoid this, the attribute "aria-hidden='true'" is applied by the default image behavior
 *  - when alt property is used in combination with aria-label, arialabbeledby or title, additional screen readers verification is needed as each screen reader handles this combination differently.
 */
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Image.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest;
        return React.createElement(ElementType, __assign({}, accessibility.attributes.root, rest, { className: classes.root }));
    };
    Image.className = 'ui-image';
    Image.displayName = 'Image';
    Image.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { accessibility: PropTypes.func, avatar: PropTypes.bool, circular: PropTypes.bool, fluid: PropTypes.bool });
    Image.defaultProps = {
        as: 'img',
        accessibility: imageBehavior,
    };
    return Image;
}(UIComponent));
Image.create = createShorthandFactory(Image, 'src');
export default Image;
